import TextArea from 'antd/es/input/TextArea';
import cN from 'classnames';
import { useEffect, useState } from 'react';
import _ from 'lodash-es';
import { ArrowRightOutlined } from '@pietra/icons';
import { useInterval, useWindowSize } from 'react-use';
import './index.less';
import Image from 'next/image';
import { STATIC_FILE_URL } from '@/shared/constants';

interface IProps {
  onClickSend: (input: string) => void;
  onClickCreateAccount: () => void;
}

const CopilotEntrypoint = ({ onClickSend, onClickCreateAccount }: IProps) => {
  const { width } = useWindowSize();
  const useMobileLayoutCards = width <= 640;

  const [askAiInput, setAskAiInput] = useState<string>();
  const [_, setPlaceholderTextIndex] = useState<number>(0);
  const [placeholderText, setPlaceholderText] = useState<string>('');

  const sendBtnDisabled = !askAiInput?.trim()?.length;

  const placeholderTextValues = [
    'e.g., Can you help me find suppliers to create a product?',
    'e.g., Can you help me find influencers to promote my business?',
    'e.g., Can you help me research trends and decide what product to launch next?',
    'e.g., Can you help me find new customer segments I should market to?',
    'e.g., Can you help me create new content to post on social?',
  ];

  const typePlaceholder = (text: string) => {
    setPlaceholderText('');
    for (let i = 0; i < text.length; i++) {
      setTimeout(() => {
        setPlaceholderText(text.slice(0, i + 1));
      }, i * 30);
    }
  };

  useEffect(() => {
    const firstText = placeholderTextValues[0];
    const timer = setTimeout(() => typePlaceholder(firstText), 300);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useInterval(() => {
    setPlaceholderTextIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % placeholderTextValues.length;
      typePlaceholder(placeholderTextValues[nextIndex]);
      return nextIndex;
    });
  }, 4000);

  const renderValueProps = () => {
    if (useMobileLayoutCards) {
      return (
        <div className="value-props">
          <Image
            className="value-prop one mobile"
            src={`${STATIC_FILE_URL}/72e53b152952248682d977ab2b637e1c.png`}
            alt="Find and contact factories"
            width={140}
            height={140}
          />
          <Image
            className="value-prop two mobile"
            src={`${STATIC_FILE_URL}/131d32ac061ed487c93ce6ba41a327ef.png`}
            alt="Find influencers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop five mobile"
            src={`${STATIC_FILE_URL}/eb0c095e018b8ba0f6816366c5bc60b2.png`}
            alt="Create assets"
            width={140}
            height={140}
          />
        </div>
      );
    } else {
      return (
        <div className="value-props">
          <Image
            className="value-prop one"
            src={`${STATIC_FILE_URL}/72e53b152952248682d977ab2b637e1c.png`}
            alt="Find and contact factories"
            width={140}
            height={140}
          />
          <Image
            className="value-prop two"
            src={`${STATIC_FILE_URL}/131d32ac061ed487c93ce6ba41a327ef.png`}
            alt="Find influencers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop three"
            src={`${STATIC_FILE_URL}/2ac96ef1baef1bd4e7747bf76674ec55.png`}
            alt="Research trends"
            width={140}
            height={140}
          />
          <Image
            className="value-prop four"
            src={`${STATIC_FILE_URL}/f01391b4a8c96dcae2a9d82058a943f6.png`}
            alt="Find customers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop five"
            src={`${STATIC_FILE_URL}/eb0c095e018b8ba0f6816366c5bc60b2.png`}
            alt="Create assets"
            width={140}
            height={140}
          />
        </div>
      );
    }
  };

  if (width === 0 || width === undefined) {
    return null;
  }

  return (
    <div className="copilot-entrypoint">
      {renderValueProps()}
      <div className="input">
        <div className="wrapper">
          <div className="text-area-wrapper">
            <TextArea
              placeholder={placeholderText}
              autoSize={{ minRows: 3, maxRows: 10 }}
              value={askAiInput}
              onChange={(e) => setAskAiInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  if (sendBtnDisabled) return;

                  onClickSend(askAiInput);
                }
              }}
            />
          </div>
          <div className="action-bar">
            <div style={{ flex: 1 }} />
            <div
              className={cN('start-copilot', {
                disabled: sendBtnDisabled,
              })}
              onClick={() => {
                if (sendBtnDisabled) return;

                onClickSend(askAiInput);
              }}
            >
              <ArrowRightOutlined style={{ color: '#fff' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="create-account-button" onClick={onClickCreateAccount}>
        Create your business AI for free <ArrowRightOutlined style={{ color: '#fff' }} />
      </div>
    </div>
  );
};

export default CopilotEntrypoint;
